import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { GuestInputComponent } from './Input';
import Error from './PlainError';

export default class GuestInput extends Component {
    static propTypes = {
        input: PropTypes.object,
        meta: PropTypes.object,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        prefix: PropTypes.node,
        disabled: PropTypes.bool,
        visibilityToggle: PropTypes.bool,
    };

    render() {
        const { input, placeholder, meta, meta: { invalid, submitFailed }, prefix, disabled, visibilityToggle } = this.props;
        const showError = invalid && submitFailed;

        return (
            <div className={cx('login-input input m-b-20', {'error has-error': showError})}>
                <GuestInputComponent
                    className='input-formfield'
                    input={input}
                    meta={meta}
                    type={input.type}
                    placeholder={placeholder}
                    prefix={prefix}
                    disabled={disabled}
                    visibilityToggle={visibilityToggle}
                />
                { showError && <Error component="p" className="help-block ant-form-explain" {...meta} /> }
            </div>
        );
    }
}
